module.exports = __webpack_public_path__ + "static/media/logout.48a1e04b.svg";